import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Modal } from 'features/common/components/Modal/Modal';
import { ErrorModalProps } from './types';
import { QUATERNARY } from 'features/common/components/Button/constants';

import { ContainerActionButtons, ContainerBody, ModalButton, Icon, Text } from './ErrorModal.styles';

export const ErrorModal: FC<ErrorModalProps> = ({ closeModal }) => {
	const { t } = useTranslation();

	return (
		<Modal onClose={closeModal}>
			<Modal.Header>{t('availability-Modal-Title')}</Modal.Header>
			<Modal.Body>
				<ContainerBody>
					<Icon iconName="alertCircleRed" />
					<Text element="p">{t('availability-Modal-Message')}</Text>
				</ContainerBody>
			</Modal.Body>
			<Modal.ActionButtons>
				<ContainerActionButtons>
					<ModalButton category={QUATERNARY} onClick={closeModal} text={t('button-dismiss')} />
				</ContainerActionButtons>
			</Modal.ActionButtons>
		</Modal>
	);
};
